import React, { useEffect, useState } from 'react';
import { Routes, Route, useLocation, Navigate, useNavigate } from 'react-router-dom';
import Header from './components/header';
import Sidebar from './components/sidebar';
import './App.css';
import MainContainer from './pages/MainContainer';
import SignIn from './pages/signIn';
import ClientMaster from './pages/ClientMaster';
import ManageKeyPer from './pages/ManageKeyPer';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ManageProject from './pages/ManageProject';
import { jwtDecode } from 'jwt-decode';
import Main from './pages/dashboard/Main';

function App() {
  const navigate = useNavigate()
  const location = useLocation();
  const token = localStorage.getItem("signIn");
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };
  const checkTokenExpire = (exp) => {
    return new Date() > new Date(exp * 1000);
  };
  const checkAuth = () => {
    const user = localStorage.getItem("signIn");
    if (user) {
      const { exp } = jwtDecode(
        localStorage.getItem("signIn")
      );
      if (checkTokenExpire(exp)) {
        return true;
      }
    }
    return false;
  };
  const isExpire = checkAuth();
  if (isExpire) {
    localStorage.removeItem('signIn');
    localStorage.removeItem('projectId');
    localStorage.removeItem('clientId');
    localStorage.removeItem('OwnerId');
    localStorage.removeItem('documentId');
    <Navigate to="/login" />;
  }
  const isLoginPage = location.pathname.includes('/login');
  
  useEffect(() => {
    if (isExpire || (isLoginPage === false && token === null)) {
      navigate('/login');
    }
  }, [isExpire, isLoginPage, navigate, token]);

  return (
    <div className={`${isSidebarOpen === false ? '' : 'toggle-sidebar'}`}>
      <div>
        <ToastContainer />
      </div>
      {!isLoginPage && !isExpire && (
        <>
          <Sidebar setSidebarOpen={setSidebarOpen} />
          <Header toggleSidebar={toggleSidebar} />
        </>
      )}

      <Routes>
        {/* <Route exact path='/login' element={<SignIn />} />
        {isExpire ? <Navigate to="/login" /> : null}
        <Route
          path='/'
          element={<>

            <MainContainer />
          </>} />
        <Route
          path='/manage-client'
          element={<ClientMaster />} 
        />
        <Route
          path='/manage-key-person'
          element={<ManageKeyPer />}
          />
          <Route
          path='/manage-project'
          element={<ManageProject />}
          /> */}

        <Route path='/' element={<MainContainer />} />
        <Route path='/manage-client' element={<ClientMaster />} />
        <Route path='/manage-key-person' element={<ManageKeyPer />} />
        <Route path='/manage-project' element={<ManageProject />} />
        <Route path='/login' element={<SignIn />} />
        <Route path='/dashboard' element={<Main />} />

      </Routes>
    </div>
  );
}

export default App;
